import { fetchFactory } from '../../../utils/fetchFactory'

export const postScanInfo = (body: { userType: string, qrCode: string, spaceId: string, equipmentOnly: boolean }): Promise<QrCodeCheckResult> => {
	return fetchFactory(`/api/admin/qrcode/info`, { method: 'POST', body: JSON.stringify(body) })
}